import React, { useRef }from "react";
import {
    Paging,
    Pager,
    FilterRow,
    ColumnChooser,
    Column,
    Export,       
    Summary,
    TotalItem, 
}
    from 'devextreme-react/data-grid';
import { DataGrid } from 'devextreme-react';
import Title from "../../components/shared/Title";
import { store } from "../../services/store";
import { cellRender, cellRenderBold  } from "../../utils/common";
import numeral from "numeral";
import BlockHeader from "../../components/shared/BlockHeader";

const Mora = props => {

    let refGrid = useRef();
   
    const onCellPrepared = e => {

        const cellsQuantity = ['payoff']

        if (e.rowType == 'data' && e.column.allowEditing) {
            if (cellsQuantity.includes(e.column.dataField))
                if (e.row.data.payoff)
                    e.cellElement.classList.add('pagada');
                else
                    e.cellElement.classList.add('pendiente');

            if (e.column.dataField == 'id')
                e.cellElement.classList.add('col-id-factura');
            if (e.column.dataField == 'reference')
                e.cellElement.classList.add('col-reference-factura');
            if (e.column.dataField == 'mora')
                if(e.row.data.mora < 0)
                    e.cellElement.classList.add('col-mora');
        }

    }

    const title = "Mora";     
    
    const customizeText = (cellInfo) => {
        return `C$ ${numeral(cellInfo.value).format('0,0.00')}`
    }

    return (
        <div className="container">
            <Title title={title}/>
            <BlockHeader title={title} showFavorite={true} {...props}>                        
            </BlockHeader>              
            <DataGrid
                ref={refGrid}
                dataSource={store({uri : { get : 'clients/mora/get' } })}
                selection={{ mode: 'single' }}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                columnHidingEnabled={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                columnAutoWidth={true}  
                onCellPrepared={onCellPrepared}        
            >
                <Pager allowedPageSizes={[10, 15, 30, 50]} showPageSizeSelector={true} showInfo={true} />
                <Paging defaultPageSize={15} />
                <FilterRow visible={true} />
                <ColumnChooser enabled={true} />
                <Export enabled={true} fileName={title} allowExportSelectedData={true} />      
                <Column dataField="name" caption="Cliente" allowHeaderFiltering={false} minWidth={100} />
                <Column dataField="mora1a15" caption="1 a 15" width={110} cellRender={cellRender()} />
                <Column dataField="mora16a30" caption="16 a 30" width={110} cellRender={cellRender()} />
                <Column dataField="mora31a60" caption="31 a 60" width={110} cellRender={cellRender()} />
                <Column dataField="mora61a90" caption="61 a 90" width={110} cellRender={cellRender()} />
                <Column dataField="mora91aMas" caption="91 a Más" width={110} cellRender={cellRender()} />
                <Column dataField="balance" caption="Saldo Total" width={110} cellRender={cellRenderBold()} />
                <Summary>                    
                    <TotalItem column="mora1a15" summaryType="sum" customizeText={customizeText} />
                    <TotalItem column="mora16a30" summaryType="sum" customizeText={customizeText} />
                    <TotalItem column="mora31a60" summaryType="sum" customizeText={customizeText} />
                    <TotalItem column="mora61a90" summaryType="sum" customizeText={customizeText} />
                    <TotalItem column="mora91aMas" summaryType="sum" customizeText={customizeText} />
                    <TotalItem column="balance" summaryType="sum" customizeText={customizeText} />
                </Summary>
            </DataGrid>
        </div>
    )


}


export default Mora;
